// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { DraftLauncherMenuItem } from "./DraftLauncherMenuItem";
import { DraftLauncherMenuList } from "./DraftLauncherMenuList";
import { DraftDataProvider } from "./DraftDataProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const DraftLauncherMenu = props => {
  // eslint-disable-next-line react/prop-types
  const {
    domain
  } = props;
  const getDraftsItems = React.useCallback(brouillons => _.map(brouillons, ({
    identifiant,
    titre,
    description,
    date,
    adresse
  }) => /*#__PURE__*/_jsx(DraftLauncherMenuItem, {
    identifiant: identifiant,
    adresse: adresse,
    titre: titre,
    date: date,
    description: description
  }, identifiant)), []);
  const renderDraftsProvider = React.useCallback(brouillons => /*#__PURE__*/_jsx(DraftLauncherMenuList, {
    items: getDraftsItems(brouillons)
  }), [getDraftsItems]);
  return /*#__PURE__*/_jsx(DraftDataProvider, {
    domain: domain,
    "data-sentry-element": "DraftDataProvider",
    "data-sentry-component": "DraftLauncherMenu",
    "data-sentry-source-file": "DraftLauncherMenu.tsx",
    children: renderDraftsProvider
  });
};